
export const scheduleData = [
  {
    day: '01',
    date: 'March 15, 2025',
    theme: 'Opening Night',
    events: [
      {
        time: '6:00 PM',
        title: 'Registration & Welcome Reception',
        description: 'Check-in, credential pickup, and opening cocktails with light refreshments',
        vipOnly: false
      },
      {
        time: '7:30 PM',
        title: 'Opening Ceremony',
        description: 'Official welcome, festival overview, and keynote address on Caribbean fashion',
        vipOnly: false
      },
      {
        time: '8:30 PM',
        title: 'Emerging Designers Showcase',
        description: 'First runway presentation featuring five rising Caribbean design talents',
        designer: 'Curated Collection',
        vipOnly: false
      },
      {
        time: '10:00 PM',
        title: 'Opening Night After-Party',
        description: 'Exclusive celebration with live music, Caribbean cuisine, and designer mingling',
        vipOnly: true
      }
    ]
  },
  {
    day: '02',
    date: 'March 16, 2025',
    theme: 'Main Event',
    events: [
      {
        time: '11:00 AM',
        title: 'Resort & Swimwear Collection',
        description: 'Beachwear and resort fashion celebrating Caribbean coastal lifestyle',
        designer: 'Multiple Designers',
        vipOnly: false
      },
      {
        time: '2:00 PM',
        title: 'Contemporary Ready-to-Wear',
        description: 'Modern interpretations of Caribbean style for everyday luxury',
        designer: 'Featured Collections',
        vipOnly: false
      },
      {
        time: '4:00 PM',
        title: 'Designer Panel Discussion',
        description: 'Conversation on Caribbean design identity and global fashion industry',
        vipOnly: true
      },
      {
        time: '7:00 PM',
        title: 'Evening Wear Gala Show',
        description: 'Formal collections showcasing Caribbean elegance and craftsmanship',
        designer: 'Signature Designers',
        vipOnly: false
      },
      {
        time: '9:30 PM',
        title: 'VIP Designer Dinner',
        description: 'Intimate dining experience with featured designers and industry leaders',
        vipOnly: true
      }
    ]
  },
  {
    day: '03',
    date: 'March 17, 2025',
    theme: 'Closing Day',
    events: [
      {
        time: '12:00 PM',
        title: 'Artisan & Craft Showcase',
        description: 'Highlighting Caribbean textile traditions and contemporary craft innovation',
        vipOnly: false
      },
      {
        time: '3:00 PM',
        title: 'Menswear Collection',
        description: 'Caribbean menswear designers presenting their latest collections',
        designer: 'Menswear Focus',
        vipOnly: false
      },
      {
        time: '6:00 PM',
        title: 'Grand Finale Runway',
        description: 'Closing show featuring all designers with signature pieces and finale walk',
        designer: 'All Designers',
        vipOnly: false
      },
      {
        time: '8:00 PM',
        title: 'Closing Celebration',
        description: 'Final night party celebrating three days of Caribbean fashion excellence',
        vipOnly: false
      }
    ]
  }
];
